export const SHARED_DIALOG_CONSTS = {
  REFERRAL_HEADER_TITLE: 'Your Personal Referral Link for Creators',
  REFERRAL_SHARE: 'referralShare',
  WELCOME_VIDEO_SHARE: 'welcomeVideoShare',
  MERCHANDISE_STORE: 'merchandiseStore',
  eventTicket: 'eventTicket',
  STORE: 'store',
  ADVERTISEMENT_SHARE: 'advertisementShare',
  ADVERTISEMENT_SHARE_TITLE: "Check out {name}'s Advertisement",
  ADVERTISEMENT_SHARE_DESCRIPTION: 'Check out this advertisement from {name} on TopFan',
  ADVERTISEMENT_LINK_COPIED: "{name}'s advertisement link copied.",
  ADVERTISEMENT_SEO_TITLE: "{name}'s Advertisement - TopFan",
  ADVERTISEMENT_SEO_DESCRIPTION: "Check out {name}'s advertisement on TopFan. {seoDesc}",
  ADVERTISER : 'Advertiser',
  TOPFANS_DEFAULT_IMAGE: 'https://cdn-www.topfans.com/topfans.png',
  TOPFANS_DEFAULT_SEO_DESCRIPTION: 'Promote your brand on TopFan, the complete creator monetization platform.',
  PORTFOLIO_SHARE: 'portfolioShare',
  RECRUITMENT_LEADERBOARD_BUTTON: 'Recruitment Leaderboard',
  LEADERBOARD_BUTTON_WHITELABEL: 'Leaderboard',
  TWITTER_SHARE_LOGIN_HINT_TITLE: 'Sharing to X',
  TWITTER_SHARE_LOGIN_HINT_BODY:
    'For the best experience, please log in to X first. Then tap OK to finish sharing.',
  PRIVATE_ACCOUNT_NOTE:
    'Note: This account is private. Only followers will be able to view this content.',
};
export const MESSAGES = {
  LINK_COPIED: 'Link Copied Successfully'
}
export const FEED_TYPE = {
  nft: 'NFT',
  nfts: 'NFTs',
  Merchandise: 'Merchandise',
  Experience: 'Experience',
  Course: 'Course',
  Downloadables: 'Downloadable',
  courses: 'Course',
  experiences:'Experience',
  merchandise: 'Merchandise',
  downloadables : 'Downloadable',
}